import { Dispatch } from "redux";
import { ModalId } from "../../../enums/modalId";
import { setOpenedModalId } from "../../../redux/slice/modalSliceNew";

export const handleSummaryStatsClick = (dispatch: Dispatch) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.SFTP_PUSH_PENDING_RECORDS_MODAL,
    }),
  );
};
